export default function getCookie(key) {
    const cookies = document.cookie
        .split(";")
        .reduce((ac, cv) => Object.assign(ac, { [cv.split("=")[0].trim()]: cv.split("=")[1] }), {})["cookieyes-consent"];
    if (!cookies)
        return undefined;
    const { [key]: value } = cookies
        .split(",")
        .reduce((obj, pair) => ((pair = pair.split(":")), (obj[pair[0]] = pair[1]), obj), {});
    return value;
}
